import React from "react";
import { Box } from "@mui/material";
import CartItemsList from "../../../components/Cart/CartItemsList";
import { CollapsibleCardBox } from "../../../components/Collapse/Collapse";
import { OrderItemImages } from "../../../components/Order/components/OrderItemImages";
import type { Item } from "../../../1_types/orderTypes";

interface OrderSummaryProps {
  commande?: Record<string, Item>;
  totalProductPriceOrder?: number;
}

const OrderSummary: React.FC<OrderSummaryProps> = ({
  commande,
  totalProductPriceOrder,
}) => {
  return (
    <CollapsibleCardBox
      title={
        <Box>
          Résumé de la commande
          <Box sx={{ pt: 1 }}>
            <OrderItemImages
              commande={commande}
              totalPrice={totalProductPriceOrder}
            />
          </Box>
        </Box>
      }
      defaultOpen
    >
      <Box sx={{ pb: 3 }}>
        <CartItemsList showDivider={false} showImage />
      </Box>
    </CollapsibleCardBox>
  );
};

export default OrderSummary;
